var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "avue-top" }, [
    _c("div", { staticClass: "top-bar__left" }, [
      _vm.showCollapse
        ? _c(
            "div",
            {
              staticClass: "avue-breadcrumb",
              class: [{ "avue-breadcrumb--active": _vm.isCollapse }],
            },
            [
              _c("i", {
                staticClass: "icon-navicon",
                on: { click: _vm.setCollapse },
              }),
            ]
          )
        : _vm._e(),
    ]),
    _c("div", { staticClass: "top-bar__title" }, [
      _vm.showMenu
        ? _c(
            "div",
            { staticClass: "top-bar__item top-bar__item--show" },
            [_c("top-menu", { ref: "topMenu" })],
            1
          )
        : _vm._e(),
      _vm.showSearch
        ? _c("span", { staticClass: "top-bar__item" }, [_c("top-search")], 1)
        : _vm._e(),
    ]),
    _c(
      "div",
      { staticClass: "top-bar__right" },
      [
        _vm.showColor
          ? _c(
              "el-tooltip",
              {
                attrs: {
                  effect: "dark",
                  content: _vm.$t("navbar.color"),
                  placement: "bottom",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "top-bar__item" },
                  [_c("top-color")],
                  1
                ),
              ]
            )
          : _vm._e(),
        _vm.showDebug
          ? _c(
              "el-tooltip",
              {
                attrs: {
                  effect: "dark",
                  content: _vm.logsFlag
                    ? _vm.$t("navbar.bug")
                    : _vm.logsLen + _vm.$t("navbar.bugs"),
                  placement: "bottom",
                },
              },
              [_c("div", { staticClass: "top-bar__item" }, [_c("top-logs")], 1)]
            )
          : _vm._e(),
        _vm.showLock
          ? _c(
              "el-tooltip",
              {
                attrs: {
                  effect: "dark",
                  content: _vm.$t("navbar.lock"),
                  placement: "bottom",
                },
              },
              [_c("div", { staticClass: "top-bar__item" }, [_c("top-lock")], 1)]
            )
          : _vm._e(),
        _vm.showTheme
          ? _c(
              "el-tooltip",
              {
                attrs: {
                  effect: "dark",
                  content: _vm.$t("navbar.theme"),
                  placement: "bottom",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "top-bar__item top-bar__item--show" },
                  [_c("top-theme")],
                  1
                ),
              ]
            )
          : _vm._e(),
        _vm.showFullScren
          ? _c(
              "el-tooltip",
              {
                attrs: {
                  effect: "dark",
                  content: _vm.isFullScren
                    ? _vm.$t("navbar.screenfullF")
                    : _vm.$t("navbar.screenfull"),
                  placement: "bottom",
                },
              },
              [
                _c("div", { staticClass: "top-bar__item" }, [
                  _c("i", {
                    class: _vm.isFullScren
                      ? "icon-tuichuquanping"
                      : "icon-quanping",
                    on: { click: _vm.handleScreen },
                  }),
                ]),
              ]
            )
          : _vm._e(),
        _c("div", { staticClass: "user-avatar_container" }, [
          _c("img", {
            staticClass: "top-bar__img",
            attrs: { src: _vm.imageUrl },
          }),
        ]),
        _c(
          "el-dropdown",
          [
            _c("span", { staticClass: "el-dropdown-link" }, [
              _vm._v(
                "\n        " + _vm._s(_vm.userInfo.userName) + "\n        "
              ),
              _c("i", { staticClass: "el-icon-arrow-down el-icon--right" }),
            ]),
            _c(
              "el-dropdown-menu",
              { attrs: { slot: "dropdown" }, slot: "dropdown" },
              [
                _c(
                  "el-dropdown-item",
                  [
                    _c("router-link", { attrs: { to: "/" } }, [
                      _vm._v(_vm._s(_vm.$t("navbar.dashboard"))),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-dropdown-item",
                  [
                    _c("router-link", { attrs: { to: "/info/index" } }, [
                      _vm._v(_vm._s(_vm.$t("navbar.userinfo"))),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-dropdown-item",
                  {
                    attrs: { divided: "" },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.logout.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("navbar.logOut")) + "\n        ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }